import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { AntDesignModule } from './ant-design/ant-design.module';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { PipesModule } from './pipes/pipes.module';
import { UuidCellComponent } from './components/uuid-cell/uuid-cell.component';

@NgModule({
  declarations: [
    SidebarComponent,
    HeaderComponent,
    FooterComponent,
    UuidCellComponent,
  ],
  imports: [
    ReactiveFormsModule,
    AntDesignModule,
    FormsModule,
    RouterModule,
    CommonModule,
    PipesModule,
    DragDropModule,
  ],
  exports: [
    ReactiveFormsModule,
    AntDesignModule,
    RouterModule,
    FormsModule,
    SidebarComponent,
    HeaderComponent,
    FooterComponent,
    UuidCellComponent,
    PipesModule,
    DragDropModule,
  ],
})
export class SharedModule {}
